import { useState } from "react";
import { Button, Col, Container, Image, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useToasts } from "react-toast-notifications";
import logo from '../../../assets/logo_stride.png';
import { ErrorMessageEnum, SuccessMessageEnum } from "../../../enums/app.enum";
import { authService } from '../../../services/auth.service';
import { utils } from '../../../_helpers';
import SSInputPhoneCode from '../../s-input/s-input-phone-code.component';
import SInputComponent from '../../s-input/s-input.component';
import TermConditionModal from '../term-condition-modal/term-condition-modal.component';
import PrivacyPolicyModal from '../privacy-pocily-modal/privacy-pocily-modal.component';

/**
 * Modal delect
 * @param {*} props Modal props
 * @param {*} props.onHide callback function when close modal
 * @returns
 */
const SignupByEmailModal = (props: any) => {
  const { clearErrors, control, handleSubmit, setError, formState: { errors } } = useForm();
  const { addToast } = useToasts();
  const [showTC, setshowTC] = useState(false)
  const [showPrivacy, setshowPrivacy] = useState(false)
  const [loading, setLoading] = useState(false)

  const onSubmit = (formData: any) => {
    setLoading(true)

    authService.register(formData).then(res => {
      addToast(SuccessMessageEnum.regisSuccess, { appearance: 'success' })
      props.onHide(null)
      setLoading(false)
    }).catch(err => {
      setLoading(false)

      if (err.response.data?.errors && err.response.data?.errors.length > 0) {
        clearErrors()
        err.response.data.errors.forEach((errorDetail: any) => {
          if (errorDetail.key) {
            setError(errorDetail.key, { type: 'manual', message: errorDetail.message })
          }
        });
      } else {
        addToast(err.response.data?.message, { appearance: 'error' })
      }
    })
  }

  return (
    <Modal {...props} animation={false} centered>
      <Modal.Body className="text-center">
        <Container>
          <Row>
            <Col>
              <Image src={logo} width="300" className="my-4" />
              <div>
                <p className='text-14'>
                  By registering to this website, you accept our <span className='text-primary pointer fw-7' onClick={() => setshowTC(true)}>Terms of Use </span>and our <span className='text-primary pointer fw-7' onClick={() => setshowPrivacy(true)}>Privacy Policy</span>
                </p>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex flex-column justify-content-center px-sm-6 mt-5">
                  {/* <SInputComponent name="username" type='text' placeholder="Username" control={control} error={errors.username}
                    rules={{ required: { value: true, message: ErrorMessageEnum.requiredFieldMessage } }} /> */}

                  <SSInputPhoneCode
                    className='mt-3'
                    control={control}
                    rules={{
                        required: { value: true, message: ErrorMessageEnum.requiredFieldMessage },
                        validate: (value: string) => {
                          return utils.validateOverseasPhoneNumber(value) ? true : 'Invalid phone number'
                        }
                    }}
                    name={`phone`}
                    error={errors.phone}
                    placeholder='+65'
                  />

                  <SInputComponent name="email" type='text' placeholder="Email" control={control} error={errors.email} className='mt-3'
                    rules={{
                      required: { value: true, message: ErrorMessageEnum.requiredFieldMessage },
                      validate: (value: string) => {
                        return utils.validEmail(value) ? true : 'Invalid email address'
                      }
                    }} />

                  <SInputComponent name="password" type='password' placeholder="Password" control={control} error={errors.password} className='mt-3'
                    rules={{
                      required: { value: true, message: ErrorMessageEnum.requiredFieldMessage },
                      validate: (value: string) => {
                        return utils.validPassword(value) ? true : 'At least 8 characters, must have uppercase and lowercase letters and numbers'
                      }
                    }} />

                  <div className='letter-86 text-graya6 text-14 text-left mt-2 px-2'>*At least 8 characters, must have uppercase and lowercase letters and numbers.</div>
                </div>
                <div className='text-center text-14 mt-4'><i>Your booking information will be saved to yọur new account</i></div>
                <div className="px-sm-6 mt-2">
                  <Button type='submit' variant='danger' block className="mt-2 py-2 btn-signup" disabled={loading}>Sign up with email</Button>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      {showTC && <TermConditionModal show={showTC} onHide={() => setshowTC(false)} onOk={() => setshowTC(false)} />}
      {showPrivacy && <PrivacyPolicyModal show={showPrivacy} onHide={() => setshowPrivacy(false)} onOk={() => setshowPrivacy(false)} />}
    </Modal >
  );
}

export default SignupByEmailModal;
